/* @flow */

export default {
  joinIcon: {
    fontSize: '1.4em',
    position: 'relative',
    left: '-0.3em',
  },
};
